/** Single source for concept-setup guidance numbers + plain-text helpers.
 *  Every surface (Advisor, subway map, create dialog, heuristics) reads these
 *  so the guidance can't drift again (it said 1–2 vs ≥2 vs 2–3 sentences and
 *  2–5 vs 3+ seeds before 2026-10-12). */

export const RESEARCH_QUESTION_SENTENCES = "2–3";
export const SEED_TARGET = { min: 3, max: 5 } as const;
export const SEED_TARGET_LABEL = `${SEED_TARGET.min}–${SEED_TARGET.max}`;

/** Strip Tiptap HTML to plain text (concept.abstract may be stored as HTML). */
export function plainText(html: string | null | undefined): string {
  if (!html) return "";
  const spaced = html.replace(/<\/(p|h[1-6]|li|blockquote|pre|div)>|<br\s*\/?>/gi, " ");
  const doc = new DOMParser().parseFromString(spaced, "text/html");
  return (doc.body.textContent ?? "").replace(/\s+/g, " ").trim();
}

export function hasResearchQuestion(abstract: string | null | undefined): boolean {
  return plainText(abstract).length > 0;
}
